module.exports = __webpack_public_path__ + "05_bob_yellow.b7a4cf8f.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/momoro/mama/layer5/05_bob_yellow.png
// module id = 7T3y
// module chunks = 0